"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var serialize_1 = require("./serialize");
var token_1 = require("./token");
exports.defaultOptions = {
    client_id: '',
    enableTokenRefresh: false,
    onLoginRedirect: redirect,
    onLogoutRedirect: redirect,
    redirect_url: '',
    url: '',
};
function assert(options) {
    ['client_id', 'url', 'redirect_url'].forEach(function (key) {
        if (!options[key]) {
            throw new TypeError("Required \"" + key + "\" not defined");
        }
    });
}
function redirect(url) {
    window.location.href = url;
    return new Promise(function () { return undefined; });
}
function clearRedirectResponse() {
    if (window.history && window.history.replaceState) {
        var url = window.location.href
            .replace(window.location.hash, '');
        window.history.replaceState(null, '', url);
    }
    else {
        window.location.hash = '';
    }
}
var Auth = (function () {
    function Auth(options) {
        assert(options);
        this.options = Object.assign({}, exports.defaultOptions, options);
    }
    Auth.prototype.init = function (tokenish) {
        var token = this.getRedirectResponse();
        if (token) {
            return token;
        }
        token = tokenish && new token_1.default(tokenish);
        if (token && token.isValid()) {
            return this.bindToken(token);
        }
        return undefined;
    };
    Auth.prototype.getRedirectResponse = function (hash) {
        if (hash === void 0) { hash = window.location.hash; }
        if (hash) {
            var token = new token_1.default(hash);
            if (token.isValid()) {
                clearRedirectResponse();
                return this.bindToken(token);
            }
        }
        return undefined;
    };
    Auth.prototype.login = function () {
        var params = {
            client_id: this.options.client_id,
            login_theme: this.options.theme,
            redirect_uri: this.options.redirect_url,
            response_type: 'token',
            scope: this.options.scope,
            state: this.options.state,
        };
        var url = this.options.url + "/oauth/authorize?" + serialize_1.stringify(params);
        return this.options.onLoginRedirect(url);
    };
    Auth.prototype.logout = function () {
        var params = {
            client_id: this.options.client_id,
            redirect_uri: this.options.redirect_url,
        };
        var url = this.options.url + "/oauth/logout?" + serialize_1.stringify(params);
        return this.options.onLogoutRedirect(url);
    };
    Auth.prototype.bindToken = function (token) {
        var _this = this;
        if (this.options.enableTokenRefresh) {
            token.startRefreshTimer(this.options.tokenRefreshTimestamp)
                .then(this.options.onTokenRefresh)
                .then(function () { return _this.login(); });
        }
        this.bindLogoutToToken(token);
        return token;
    };
    Auth.prototype.bindLogoutToToken = function (token) {
        var _this = this;
        var tokenLogout = token.logout;
        Object.defineProperty(token, 'logout', {
            enumerable: false,
            value: function () {
                tokenLogout.call(token);
                _this.logout();
            },
        });
    };
    return Auth;
}());
exports.default = Auth;
//# sourceMappingURL=auth.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/auth-client/lib/auth.js
// module id = 732
// module chunks = 0